import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgFeedbackSuccess(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.091 48.435c-4.68-4.68-12.267-4.68-16.947 0s-4.68 12.268 0 16.948l22.825 22.826c4.68 4.68 12.268 4.68 16.948 0s4.68-12.267 0-16.947L37.09 48.435Z"
        fill="#78B441"
      />
      <path
        d="M82.915 31.316c4.68-4.68 12.268-4.68 16.948 0s4.68 12.267 0 16.947L59.918 88.21c-4.68 4.68-12.268 4.68-16.948 0s-4.68-12.267 0-16.948l39.945-39.945Z"
        fill="#78B441"
      />
      <path
        d="M44.85 89.745a12.04 12.04 0 0 1-1.88-1.536c-4.68-4.68-4.68-12.268 0-16.948l8.474-8.474 8.473 8.474c4.68 4.68 4.68 12.268 0 16.948-.51.51-1.056.966-1.628 1.365a11.997 11.997 0 0 1-13.44.17Z"
        fill="#599F40"
      />
      <path
        d="m26.36 31.27 1.231-3.748a.6.6 0 0 0-.316-.73l-1.712-.8a.6.6 0 0 0-.85.607l.48 4.547c.069.643.966.739 1.167.124Z"
        fill="#42A486"
      />
      <path
        d="m50.305 50.63 1.755-1.755a.6.6 0 0 0 .157-.57l-.35-1.404a.6.6 0 0 0-1.131-.098l-1.404 3.159c-.27.607.502 1.138.973.668Z"
        fill="#378CC8"
      />
      <path
        d="m27.479 56.336 1.754-1.755a.6.6 0 0 0 .158-.57l-.35-1.403a.6.6 0 0 0-1.131-.098l-1.404 3.158c-.27.608.502 1.139.973.668Z"
        fill="#42A486"
      />
      <path
        d="m58.775 39.637-2.94-2.631a.6.6 0 0 1-.091-.791l1.083-1.548a.6.6 0 0 1 1.04.1l1.857 4.179c.262.59-.467 1.122-.949.69Z"
        fill="#FC0"
      />
      <path
        d="m96.468 73.876 2.94-2.63a.6.6 0 0 0 .092-.792l-1.083-1.547a.6.6 0 0 0-1.04.1l-1.857 4.178c-.263.591.467 1.122.948.691Z"
        fill="#42A486"
      />
      <path
        d="m81.602 88.29-2.94-2.632a.6.6 0 0 1-.092-.79l1.083-1.548a.6.6 0 0 1 1.04.1l1.857 4.178c.263.591-.467 1.122-.948.691ZM86.626 29.936l2.94-2.631a.6.6 0 0 0 .092-.791l-1.084-1.548a.6.6 0 0 0-1.04.1l-1.856 4.179c-.263.59.466 1.122.948.69Z"
        fill="#FC0"
      />
      <path
        d="M73.197 27.242v-2.481a.6.6 0 0 0-.292-.515l-1.24-.744a.6.6 0 0 0-.87.73l1.242 3.226c.238.62 1.16.45 1.16-.216Z"
        fill="#378CC8"
      />
      <path
        d="m107.251 52.155-2.15 1.24a.6.6 0 0 1-.591.006l-1.265-.703a.6.6 0 0 1 .198-1.117l3.414-.538c.657-.104.97.78.394 1.112Z"
        fill="#42A486"
      />
      <path
        d="m29.165 84.952-1.231-3.749a.6.6 0 0 1 .316-.73l1.712-.8a.6.6 0 0 1 .85.608l-.48 4.546c-.069.644-.966.739-1.167.125Z"
        fill="#FC0"
      />
      <path
        d="m17.484 70.878-2.631 2.94a.6.6 0 0 1-.791.092l-1.548-1.084a.6.6 0 0 1 .1-1.04l4.179-1.856c.59-.263 1.122.466.69.948Z"
        fill="#42A486"
      />
      <path
        d="m17.484 42.598-2.631-2.94a.6.6 0 0 0-.791-.092l-1.548 1.084a.6.6 0 0 0 .1 1.04l4.179 1.856c.59.263 1.122-.466.69-.948ZM56.775 86.637l-2.94 2.63a.6.6 0 0 0-.091.792l1.083 1.547a.6.6 0 0 0 1.04-.1l1.857-4.178c.262-.591-.467-1.122-.949-.691Z"
        fill="#FC0"
      />
      <path
        d="m37.837 93.41-2.94 2.63a.6.6 0 0 0-.092.792l1.084 1.547a.6.6 0 0 0 1.04-.1l1.856-4.178c.263-.59-.466-1.122-.948-.69Z"
        fill="#42A486"
      />
      <path
        d="M79.903 53.379v2.481a.6.6 0 0 1-.291.515l-1.241.744a.6.6 0 0 1-.869-.73l1.241-3.226c.239-.62 1.16-.45 1.16.216Z"
        fill="#378CC8"
      />
    </svg>
  )
}
export default wrapIllustration(SvgFeedbackSuccess)
